module.exports = __webpack_public_path__ + "assets/img/gzh.b1543e2b.png";